let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("18eMn")).then(() => parcelRequire('jy2NA'));